import React from "react";

import { Button, Text } from "src/components";

export default ({
  color = "white",
  title,
  titleProps,
  subTitle,
  subTitleProps,
  ...props
}) => (
  <Button
    type="submit"
    bg={props.disabled ? "greenTransparent" : "green"}
    flex="1 0 auto"
    borderWidth={0}
    borderRadius={5}
    p={1}
    py={2}
    color="white"
    align="center"
    justify="center"
    textAlign="center"
    {...props}
  >
    <Text
      color={color}
      fontWeight="semibold"
      numeric={props.numeric}
      {...titleProps}
    >
      {title}
    </Text>
    {subTitle && (
      <Text color="white" fontWeight="regular" {...subTitleProps} ml={1}>
        {subTitle}
      </Text>
    )}
  </Button>
);



// WEBPACK FOOTER //
// ./src/components/Form/Button.js